const PACIFIC_TIME_ZONE = 'America/Los_Angeles';

export function getHomeGreeting(now: Date): string {
  const hour = Number(new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    hourCycle: 'h23',
    timeZone: PACIFIC_TIME_ZONE
  }).format(now));
  if (hour < 12) {
    return 'Good morning';
  }
  if (hour < 18) {
    return 'Good afternoon';
  }
  return 'Good evening';
}

export function getHomeDateLabel(now: Date): string {
  return new Intl.DateTimeFormat('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    timeZone: PACIFIC_TIME_ZONE
  }).format(now);
}
